import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import S from './styles';

function ModalRDStation({ titulo, visivel, setVisivel }) {
  const onCancel = () => {
    setVisivel(false);
  };

  useEffect(() => {
    if (visivel && !window.hbspt) {
      // Carrega o script do HubSpot
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/50794376.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, [visivel]);

  return (
    <S.Modal
      key="modal-rd-station"
      title={titulo}
      open={visivel}
      width={784}
      centered
      destroyOnClose
      onCancel={() => onCancel()}
      footer={null}
    >
      <div
        id="modal-rd-station-content"
        style={{
          width: '100%',
          minHeight: '200px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="33c7e66a-1d45-4674-bf03-2744ebe99816"
          data-portal-id="50794376"
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      </div>
    </S.Modal>
  );
}

ModalRDStation.defaultProps = {
  titulo: '',
};

ModalRDStation.propTypes = {
  titulo: PropTypes.string,
  visivel: PropTypes.bool.isRequired,
  setVisivel: PropTypes.func.isRequired,
};

export default ModalRDStation;
